import { GoogleAuthProviderButton, GoogleSignInButton } from "./google";
import { AuthProviderCallbacks, InteractionProps } from "./types";

import { AuthenticationMethod } from "common/Database";
import { AppFeatures } from "common/components/SerializedApp";
import { convertOAuth2RedirectTokenToState } from "../../../../lib/auth";
import { isPlayer } from "../../../../../routes";

type MethodFeatures = Readonly<{
    authMethod: AuthenticationMethod | undefined;
    appFeatures: AppFeatures | undefined;
}>;

type Props = MethodFeatures & AuthProviderCallbacks & InteractionProps;

// Note that we haven't yet solved the branding issue.
// We're punting that to the app authors right now, but
// eventually we'll have to expose custom Sign in with Google
// properties to remove the branding.
export function canShowExternalAuthButtons(appFeatures: AppFeatures | undefined): boolean {
    return appFeatures?.showSignInWithGoogle === true;
}

export function ExternalAuthProviderButtons(props: Props): JSX.Element | null {
    if (!canShowExternalAuthButtons(props.appFeatures)) {
        return null;
    }
    if (!isPlayer()) {
        return <GoogleSignInButton userAgreed={props.userAgreed} />;
    }
    // We can't show any of the external auth buttons if we don't have any state
    // to pass through the authentication flows: that state is what tells the
    // receiving Cloud Function to redirect to us!
    const oauth2State = convertOAuth2RedirectTokenToState();
    if (oauth2State === undefined) {
        return null;
    }

    return <GoogleAuthProviderButton {...props} />;
}
